var pharmacies = {

    baseUrl : 'https://uni-ecomm-shopify.azurewebsites.net/api/',
    token   : 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZiMGQzNWU1MWZmOTFjNjM1YjFiNzM1NDE4NjVlZTVkNTUzODRmMDNhODEzZmYyZDE2Y2VhZDQ3ZTc5YWYxYjAxMDBhODRiNjkwZjhmNzc2In0.eyJhdWQiOiIxIiwianRpIjoiZmIwZDM1ZTUxZmY5MWM2MzViMWI3MzU0MTg2NWVlNWQ1NTM4NGYwM2E4MTNmZjJkMTZjZWFkNDdlNzlhZjFiMDEwMGE4NGI2OTBmOGY3NzYiLCJpYXQiOjE3NjQwODQ1MTYsIm5iZiI6MTc2NDA4NDUxNiwiZXhwIjoxNzk1NjIwNTE2LCJzdWIiOiIyIiwic2NvcGVzIjpbXX0.h5QN9IyPjVTbeE9yWH_tKrOrazGVPcHa6kYY6PHV_-TnIcrXWSa1vJQmqnHiP4ZnqMepE7bldotKyYtxCmfwpxOsV6kP2XAQWoJi65lK3g7szYtCG5YWx9p9dCOlYzYDUUp4HQ7AbYwu_lD7JfwXfzowLUt9lXGLrpDLaND6hr3XJ8enUXbNsuNBkJvnVLWGbgXDMAMI83W-tBl_V0Kw7WN5vbVIbkZmcVrdkpZ9byeAw9-YTcOGT75zlFqhDZZLeVijl7UMTnSj6XnXAmfW9ss6tAgoN0n-ICw9NHNzATwIY0RGcXDqun_atahs8U5cPGpH66fdu1S_3Unu0ZzWgD9V4R3J5ublo-hmE77VaAD4D2Ok_QqjqCbCrSzL4UPItIEaYGILxV6wrfaoQIvD3eIjhujXd2Bmx-BGSHXTcKU4H1qKZ_knbzAtTn4PblHc0w9_Ybyqok_wyZFGwfdkTY7gjLqeAXd3dbRKsaYEtqvcqENFO2EsIkQiqHC8XMNs1rEFC532vE0BEkCujeqrfsTXMwfEdD3YonF4YGWbfNPmWXpXRlTWyBABkz-TdFhpoAuMo12cIZhpNJPwzmDmd-eeuef-YUlAxeY2nnvjN4mEIlNPMtyWAmJzabwnaWo3x-apG8r_d77fJ8O0d-NBlUOdy-Q2AgoeuvHFMSvQdtY',
    firstInit: 0,
    customerNoPh: typeof window.customerNoPh == 'boolean' && window.customerNoPh,
    userPhCode: null,


    init: function(){
        this.getPharmacies();
        this.checkCustomerPh();
        this.setPharmacyElements();
        if(!this.customerNoPh){
            this.productFormNoPharmacy(true);
            this.initModal();
        }
        this.checkPharmacyParams();
    },

    modalInfo: function(){

            $.magnificPopup.open({
                mainClass: 'mfp-fade',
                fixedContentPos: true,
                items: {
                    src: '#info-modal',
                    type: 'inline',
                },
                callbacks: {
                    open: function() {
                        var $wrap = $(this.wrap);
                        $wrap.removeAttr('tabindex');
                    },
                    close: function() {
                        $.cookie('info-modal',true,{path:'/'});
                    }
                }
            })

        $('.info-modal__click').on('click', function(){
            this.modalInfo();
        });
    },

    productFormNoPharmacy: function($form){

        var tmp = "";

        if($('.pharmacy-msg').hasClass("new_pdp")){
            tmp = `<div class="alert-msg">
                        <b>Per proseguire con l&#39;acquisto sul sito, imposta una farmacia di riferimento.<br>Te lo chiediamo per garantirti un punto di riferimento autorevole sul territorio. Potrai sempre decidere se ritirare il tuo ordine in farmacia o riceverlo a casa.</b>
                        <br><br>
                        Seleziona dalla lista:
                   </div>`;
        } else {
            tmp = `<div class="alert-msg"><b>Per proseguire con l&#39;acquisto sul sito, imposta una farmacia di riferimento.</b><a href="javascript:;" class="info-modal__click" onclick="pharmacies.modalInfo();">
                        <svg width="22" height="22" class="pharmacy-select__info-icon">
                            <use href="#theme_svg_info_icon" xlink:href="#theme_svg_info_icon"/>
                        </svg></a><br><br>Te lo chiediamo per garantirti un punto di riferimento autorevole sul territorio. Potrai sempre decidere se ritirare il tuo ordine in farmacia o riceverlo a casa.<br><br>
                        Seleziona dalla lista:
                    </div>`;
        }

        if(typeof $form == "boolean"){

            // Force setting on init based on pharmacy selected
            if($form === true){
                $('.ph-notice').addClass('alert-notice');
                $('.product-form').addClass('no-pharmacy-set');
                $('.new__pdp__product__submit__add').addClass('no-pharmacy-set');
                $('.pharmacy-msg').html(tmp);
            } else {
                $('.product-form').removeClass('no-pharmacy-set');
                $('.new__pdp__product__submit__add').removeClass('no-pharmacy-set');
                $('.ph-notice').removeClass('alert-notice');
                $('.pharmacy-msg').html('');
                this.customerNoPh = true;
            }

        } else if (typeof $form == "object") {

            // Force setting on form interaction baset on pharmacy selected and return status
             if(!this.customerNoPh){
                var pId = $form.find('.product__submit').data('product-id'),
                $phSelWrap = $('.pharmacy-select-wrap--' + pId);

                $form.addClass('no-pharmacy-set');
                $('.new__pdp__product__submit__add').addClass('no-pharmacy-set');
                $('.ph-notice').removeClass('alert-notice');
                $('.ph-notice').addClass('alert-error');
                $('.pharmacy-msg').html(tmp);
                $('.pharmacy-msg .ph-notice', $phSelWrap).addClass('alert-error').removeClass('alert-notice');
                $('.pharmacy-select', $phSelWrap).select2('open');
                goToPos($phSelWrap);

                return false;
            } else {
                $form.removeClass('no-pharmacy-set');
                $('.new__pdp__product__submit__add').removeClass('no-pharmacy-set');
                $('.pharmacy-msg').html('');

                return true;
            }

        }
    },

    checkCustomerPh: function(){

        // Special type of customers (dip/coll) cannot choose the pharmacy
        if(this.customerNoPh) this.unsetPharmacy();

        var storedPh = JSON.parse(localStorage.getItem('pharmacy_details'));

        if(storedPh != null){
          this.userPhCode = storedPh.CodiceX3;
          this.setPharmacyCartAttributes(storedPh);
        } else {
          if(window.customerNoPh){
            // Sets cart default unifarco pharmacy
            this.setPharmacyCartAttributes();
          } else {
            // Empty cart pharmacy data
            this.setPharmacyCartAttributes('unset');
          }
        }

        // Align the information stored local storage with the shopify customer tag
        if(typeof window.customerPh === 'string' && !this.customerNoPh){

            if(storedPh == null || storedPh.CodiceX3 != window.customerPh){
                this.setPharmacy(window.customerPh, false, location);
            }

        }

    },

    openModal: function () {
        $.magnificPopup.open({
            mainClass: 'mfp-fade',
            fixedContentPos: true,
            items: {
                src: '#ph-modal',
                type: 'inline',
            },
            closeOnBgClick: false,
            callbacks: {
                open: function() {
                    var $wrap = $(this.wrap);
                    $wrap.removeAttr('tabindex');
                    if(!window.customerNoPh) $wrap.find(".mfp-close").addClass("hidden");
                },
                close: function() {
                    $.cookie('ph-modal',true,{path:'/'});
                }
            }
        });
    },

    initModal: function(){

        if(this.customerNoPh) return false;

        var $modal = $('#ph-modal'),
            $select = $modal.find('.pharmacy-select'),
            ph = JSON.parse(localStorage.getItem('pharmacy_details')),
            phCookie = $.cookie('ph-modal'),
            self = this;

        $('.pharmacy-select__click').on('click', function(){
            self.openModal();
        })

        this.initSelect($select);

        if($modal.length==1 && ph == null && phCookie == null && $modal.attr('data-modal-auto-open') == 'true'){
            setTimeout(function(){
                self.openModal();
            }, 5000);
        }
    },

    setPharmacyElements: function(phCode){

        var self = this;
        var ph = JSON.parse(localStorage.getItem('pharmacy_details'));
        var fetched_id = self.getUrlParam('id','not-set');

        // Set UI elements for selected pharmacy for not logged user
        if(ph !== null){
            this.setPharmacyLogos(ph);
            $('.pharmacy-select').val(ph.CodiceX3);
            self.setLocatorBtns(ph);
            self.populateProductPhInfo(ph);
            if(fetched_id == "not-set") self.populateAccountPhInfo(ph);
            self.productFormNoPharmacy(false);
            self.setPharmacyProductImages(ph.CodiceX3Prodotti || ph.CodiceX3);
            self.setPharmacyProductShare(ph.CodiceX3, ph.CodiceX3Prodotti);
            self.setNewsletterTag(ph.CodiceX3);

        } else {
            $('.pharmacy-select__click').show();
        }

    },

    setLocatorBtns(ph){
        $('.ph-map__results .setPharmacy').attr('data-active', 0);
        $('.ph-map__results .setPharmacy[data-code="'+ ph.CodiceX3 +'"]').attr('data-active',1);

        if(typeof phMap != 'undefined'){
            phMap.userPhCode = ph.CodiceX3;
            phMap.setUserPharmacy(ph.CodiceX3);
        }
    },

    getPharmacyPageUrl: function(ph){
        return (!window.customerLogged) ? '/pages/farmacia-dettaglio?n='+ encodeURIComponent(ph.NomeFarmacia) +'&id='+ ph.CodiceX3 : '/account?view=pharmacy';
    },

    announcementSuccessBar: function(){
        if (typeof pharmacySelctedBannerSettings != 'undefined') {
            var paddingTop = $('#MainContent').css('padding-top', '');
            var template = `
            <div class="tooltipbar" style="background-color:${pharmacySelctedBannerSettings.bgColor}; color: ${pharmacySelctedBannerSettings.color}; top:${paddingTop}; left: 0;">
                <div class="tooltipbar__icon">
                    <svg width="36" height="36" style="fill: ${pharmacySelctedBannerSettings.color};"><use href="#theme_svg_fireworks" xlink:href="#theme_svg_fireworks"/></svg>
                </div>
                <div class="tooltipbar-text">
                ${pharmacySelctedBannerSettings.text}
                </div>
            </div>`;
            $('#MainContent').prepend(template);
            setTimeout(function() {
                $('#MainContent .tooltipbar').remove();
            }, 16000);
        }
    },

    setPharmacyLogos: function(ph){

        var $logo = $('#logo-ph'),
            $logoSpec = $('#logo-ph-spec'),
            phIdTrimmed = ph.CodiceX3Logo,
            phImageLink = (ph.CodiceX3Logo != null) ? ph.LogoFarmacia.replace(ph.CodiceX3, phIdTrimmed) : ph.LogoFarmacia;

        $logo.toggleClass('hide',(ph.AderenteReteFP==1));
        $logoSpec.toggleClass('hide',(ph.AderenteReteFP==0));


        var logoUrl = this.getPharmacyPageUrl(ph);

        $('.logo__pharmacy-wrapper').html('<a href="'+ logoUrl +'" class="tooltip"><img src="'+ phImageLink +'" alt="" height="74"><div class="tooltiptext"><svg width="22" height="22" class="pharmacy-select__info-icon" style="fill:#000;"><use href="#theme_svg_info_icon" xlink:href="#theme_svg_info_icon"/></svg><span class="tooltip__content">Scopri gli orari e i contatti della tua farmacia</span></div></a>');
    },

    setPharmacyProductShare: function(phCode, phProduct){

        // Set the correct fb share url
        var $fbBtn = $('.product__sharing .fb-share'),
            $ptBtn = $('.product__sharing .pt-share'),
            $twBtn = $('.product__sharing .tw-share'),
            $cpBtn = $('.product__sharing .copy-share input');

        if($fbBtn.length == 0 && $ptBtn.length == 0 && $twBtn.length == 0) return false;

        var pImageUrl = phProdBaseUrl + phProduct +'/'+ window.productSKU +'.PNG'
            pageUrl = encodeURIComponent(window.location.origin + window.location.pathname + '?phId=' + phCode );

        // Facebook
        if($fbBtn.length > 0){
            var baseUrl = $fbBtn.attr('data-baseurl');

            $fbBtn.attr('href', baseUrl + pageUrl );
        }

        // Twitter
        if($twBtn.length > 0){
            var baseUrl = $twBtn.attr('data-baseurl'),
                title   = $twBtn.attr('data-title');

            $twBtn.attr('href', baseUrl + title + '&url=' + pageUrl );
        }

        // Pinterest
        if($ptBtn.length > 0){
            var baseUrl = $ptBtn.attr('data-baseurl'),
                title   = $ptBtn.attr('data-title');

            $ptBtn.attr('href', baseUrl + pageUrl + '&media=' + pImageUrl + '&description?' + title );
        }

        // Copy
        if($cpBtn.length > 0){
            var copyAddress = window.location.origin + window.location.pathname + '?phId=' + phCode;

            $cpBtn.val(copyAddress);
        }
    },

    setNewsletterTag: function(phCode){

        if($('#form-nw__tags').length == 0) return;
        // Add pharmacy code tag on newsletter form
        $('#form-nw__tags').val(function(){
            var val = this.value.split(',ph|');
            return val[0] + ',ph|' + phCode;
        });
    },

    setPharmacyProductImages: function(phCode){

        // If pharmacy code is not set we try to retrieve it form localStorage.
        if(typeof phCode === 'undefined'){
            var ph = JSON.parse(localStorage.getItem('pharmacy_details'));
            if(ph !== null){
                phCode = ph.CodiceX3Prodotti || ph.CodiceX3;
            } else {
                // If is not set we stop here
                return false;
            }
        }

        var $elems = $('[data-ph-prod-image]');

        if($elems.length > 0){

            $elems.each(function(){
                var $el = $(this),
                    pId = $el.attr('data-ph-prod-image');

                    var pImageUrl = phProdBaseUrl + phCode +'/'+ pId +'.PNG';

                // We have a background Product image
                if($el.hasClass('replaceWithPhImageBg')){
                    $el.removeAttr('data-bgset');
                    $el.css({
                        'background-image' : 'url('+ pImageUrl +')'
                    });

                    //Resize bug fix
                    if($el.children.length > 0){
                        $el.empty();
                    }
                }

                if($el.hasClass('replaceWithPhImage')){
                    $el.removeAttr('data-src');
                    $el.attr('src',pImageUrl);
                    $el.attr('srcset',pImageUrl);
                }
            });

        }

        /*
        if($('body').hasClass('template-product')){

            // Set the correct og:image for product details page
            var pImageUrl = phProdBaseUrl + phCode +'/'+ window.productSKU +'.PNG';

            var $meta = $('meta[property="og:image"]');

            $meta.attr('content',pImageUrl);

        }*/
    },

    unsetPharmacy: function(){
        localStorage.removeItem('pharmacy_details');
    },

    formatPharmacyCountryForCheckout(country){

      let ret = country;

      switch (country) {
        case 'ITALIA':
          ret = 'IT'
          break;
        case 'GERMANIA':
          ret = 'DE'
          break;
        case 'FRANCIA':
          ret = 'FR'
          break;
        case 'SPAGNA':
          ret = 'ES'
          break;
        case 'AUSTRIA':
          ret = 'AT'
          break;
        case 'REGNO UNITO':
          ret = 'UK'
          break;
      }

      return ret;
    },

    setPharmacyCartAttributes: function(ph) {

      if(ph == undefined){
        // UNIFARCO Pharmacy
        ph = {
          'RagioneSociale1': `Unifarco S.p.A.`,
          'CodiceX3': `C999991`,
          'Via': `Via Cal Longa, 62`,
          'Citta': `SANTA GIUSTINA`,
          'Nazione': `IT`,
          'Provincia': `BL`,
          'CAP': `32035`
        }
      }

      if(ph == 'unset'){
        // Unset data
        ph = {
          'RagioneSociale1': '',
          'CodiceX3': '',
          'Via': '',
          'Citta': '',
          'Nazione': '',
          'Provincia': '',
          'CAP': ''
        }
      }

      $.ajax({
          url: '/cart/update.js',
          method: 'POST',
          dataType: "json",
          data: {attributes: {
            'pharmacy_RagioneSociale1': `${ph.RagioneSociale1}`,
            'pharmacy_CodiceX3': `${ph.CodiceX3}`,
            'pharmacy_Via': `${ph.Via}`,
            'pharmacy_Citta': `${ph.Citta}`,
            'pharmacy_Nazione': `${this.formatPharmacyCountryForCheckout(ph.Nazione)}`,
            'pharmacy_Provincia': `${ph.Provincia}`,
            'pharmacy_CAP': `${ph.CAP}`,
            'customer_type': `${window.customerType}`
          }},
          success: function(result) {

          },
          error: function(jqxhr, status, exception) {
              console.log(exception);
          }
      });
    },

    setPharmacy: function(ph,showMessage, location){

        var self =  this;

        showMessage = (typeof showMessage != 'undefined') ? showMessage : true;
        showMessage = false;

        // If specal customer tries to add a pharmacy, let's stop (kindly) stop him.
        if(customerNoPh != undefined && customerNoPh){
            Swal.fire({
                type: 'warning',
                html: 'Il tuo tipo di account non permette la scelta di una farmacia',
                showConfirmButton: true,
                timer: 3000,
                buttonsStyling: false,
                customClass: {
                    confirmButton: 'theme-btn theme-btn--gray-darker'
                }
            });
            return false;
        }

        // if we receive the code, then we get full pharmacy details
        if(typeof ph === 'string'){
            this.getPharmacy(ph,'pharmacies.setPharmacy', showMessage, false, location);
            return false;
        }

        // if we receive the pharmacy object then we proceed

        // Check if we are changing pharmacy
        var storedPh = JSON.parse(localStorage.getItem('pharmacy_details'));

        const hideMessageSetting = true;

        if((storedPh == null || storedPh.CodiceX3 != ph.CodiceX3) && showMessage){

            var msg = (storedPh == null ) ? '<h3>Vuoi impostare la tua farmacia di fiducia?</h3><br>La farmacia sarà<br><b>' + ph.NomeFarmacia + '</b>' : '<h3>Vuoi cambiare la tua farmacia di fiducia?</h3><br>La nuova farmacia sarà<br><b>' + ph.NomeFarmacia + '</b>';

            Swal.fire({
                type: 'warning',
                html: msg,
                showConfirmButton: true,
                showCancelButton: true,
                buttonsStyling: false,
                confirmButtonText: 'Imposta farmacia',
                cancelButtonText: 'No, grazie',
                customClass: {
                    confirmButton: 'theme-btn theme-btn--gray--darker',
                    cancelButton: 'theme-btn theme-btn--outline',
                    actions: 'ph-popup__btns'
                }
            }).then(function(result){
                if (result.value) {
                    self.savePharmacyAndUpdateInterface(ph,hideMessageSetting, location);
                } else if(typeof result.dismiss != 'undefined' && result.dismiss == 'cancel'){
                    $('.pharmacy-select').val(self.userPhCode).trigger('change');
                }
            });

        } else {
            self.savePharmacyAndUpdateInterface(ph,hideMessageSetting, location);
        }

        this.firstInit = 1;

    },

    savePharmacyAndUpdateInterface(ph,showMessage, location){

        // Save the data in local storage
        localStorage.setItem('pharmacy_details',JSON.stringify(ph));

        // update data on object
        this.userPhCode = ph.CodiceX3;

        // if user is logged in we update pharmacy tag
        this.setCustomerPharmacy(ph);

        // set pharmacy data to cart (checkout update strategy)
        this.setPharmacyCartAttributes(ph);

        if(typeof window.checkoutPharmacyChanged === 'function') window.checkoutPharmacyChanged();

        if(showMessage){
            if(typeof Swal === 'function'){
                const templateCollection = document.querySelector(".template-collection");
                const templateProduct = document.querySelector(".template-product");
                const templateRegister = document.querySelector(".template-register");
                let redirect;
                if (templateCollection || templateProduct || templateRegister) {
                    redirect = 'href="javascript:;" onclick="swal.close()"';
                } else {
                    redirect = 'href="/"';
                }
                const html = `<div class="ph__selected">
                        <div class="ph__selected__label">Hai selezionato</div>
                        <div class="ph__selected__image--wrapper">
                            <img src="${ph.LogoFarmacia}" alt="${theme.pharmacyLocator['strings']['pharmacyLogoAlt']}" class="ph__selected__image" style="max-width:300px;"/>
                        </div>
                        <div class="ph__selected__title">
                            <span>${ph.NomeFarmacia}</span>
                        </div>
                        <div class="ph__selected__data">
                            <span class="ph__selected__row">${theme.pharmacyLocator['strings']['popUp']}</span>

                        </div>
                        <a ${redirect} class="ph__selected__btn theme-btn theme-btn--blue">Inizia gli acquisti sul sito</a>
                    </div>`;
                    Swal.fire({
                        html: html,
                        showConfirmButton: false,
                        buttonsStyling: false,
                        showCloseButton: true,
                        closeButtonHtml: `<svg width="13" height="13">
                                        <use href="#theme_svg_close" xlink:href="#theme_svg_close"/>
                                    </svg>`,
                        customClass: {
                            popup: 'ph__selected__container',
                            closeButton: 'ph__selected__btn--close'
                        }
                    });
            } else {
                window.alert('La tua farmacia è: '+ ph.NomeFarmacia +'!');
                $('.pharmacy-select').trigger('change.select2');
            }
            this.announcementSuccessBar();
        }

        // Align select with selected value in case we set the value from external UI elements
        $('.pharmacy-select').val(ph.CodiceX3).trigger('change.select2');

        $('.ph-notice').removeClass('alert-error').addClass('alert-notice');

        // Let's close pharmacy modal if open
        var magnificPopup = $.magnificPopup.instance;
        if(typeof magnificPopup.close === 'function')  magnificPopup.close();

        // Hide the nearby pharmacy adivce if present
        $('.pharmacy-select__nearby-msg').removeClass('show');
        this.setPharmacyElements();
        GTM.trackFavPharmacy(ph, location);
    },

    setCustomerPharmacy: function(ph){

        if(!window.customerLogged) return false;

        var self = this;
        $.ajax( {
            dataType: 'json',
            url: self.baseUrl + "customers/update_customer_tags",
            type: "POST",
            cache: false,
            headers: {
                "Authorization" : self.token
            },
            data: {
                id : window.customerId,
                tags: 'ph|'+ph.CodiceX3,
                customerToken: window.customerToken,
                storecode: 'it'
            },
            beforeSend: function(){
            },
            complete: function(){
            },
            success: function( result ) {

                if(typeof result[0] === 'object'){

                    if(callback){
                        self.executeFunctionByName(callback, window, result[0]);
                    }
                }

            },
            error: function() {
                console.warn('some error occoured!');
            }
        });
    },

    checkPharmacyParams: function(){
        var id = this.getUrlParam('id','not-set'),
            idNoMessage = this.getUrlParam('phIdNm','not-set'),
            phId = this.getUrlParam('phId','not-set'),
            phEcLink = this.getUrlParam('phEcLink','not-set'),
            storedPh = JSON.parse(localStorage.getItem('pharmacy_details')),
            promptMessage = true;

        if(storedPh != null && storedPh.CodiceX3 != id) promptMessage = true;

        if(typeof id != 'undefined' && id != '' && id != 'not-set' && window.location.pathname == '/'){

            this.getPharmacy(id,'pharmacies.setPharmacy', promptMessage, '', location);

        } else if (typeof phId != 'undefined' && phId != '' && phId != 'not-set'){

            this.getPharmacy(phId,'pharmacies.setPharmacy', promptMessage, '', location);

        } else if (typeof phEcLink != 'undefined' && phEcLink != '' && phEcLink != 'not-set'){

            this.getPharmacy({EcommerceLink:phEcLink},'pharmacies.setPharmacy', promptMessage, '', location);

        } else if (typeof idNoMessage != 'undefined' && idNoMessage != '' && idNoMessage != 'not-set'){

            this.getPharmacy(idNoMessage, 'pharmacies.setPharmacy', false, '', location);
        }
    },

    getUrlParam: function(parameter, defaultvalue){

        var urlparameter = defaultvalue;
        if (window.location.href.indexOf(parameter) > -1) {
            urlparameter = this.getUrlVars()[parameter];

            // Removes hashtag in case we have
            if(typeof urlparameter != 'undefined'){
                urlparameter = urlparameter.replace(window.location.hash,'');
            }
        }
        return urlparameter;
    },

    getUrlVars: function() {
        var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
            vars[key] = value;
        });
        return vars;
    },

    getPharmacy: async function(phCode, callback, showMessage, temp, location){
        var self = this;
        var data = {};
        showMessage = (typeof showMessage != 'undefined') ? showMessage : true;
        temp = (typeof temp != 'undefined') ? temp : true;

        if(typeof phCode == 'string'){
            // Default function uses the X3code
            data = {
                CodiceX3 : phCode
            }

        } else if(typeof phCode == 'object'){

            // Custom call with several parameters
            data = phCode;
        }

        // Let's add the multistore parameter
        data.storecode = 'it';

        if(!callback) var phDetails = null;

        await $.ajax( {
            dataType: 'json',
            url: self.baseUrl + "pharmacies/get_pharmacy",
            type: "POST",
            cache: false,
            headers: {
                "Authorization" : self.token
            },
            data: data,
            beforeSend: function(){

                if(callback === 'pharmacies.setPharmacy' && showMessage){

                    if(typeof Swal === 'function'){
                        Swal.fire({
                            type: 'info',
                            html: 'Stiamo elaborando la richiesta<div class="loader"><div class="loader-indeterminate"></div></div>',
                            showConfirmButton: false
                        });
                    }
                }

            },
            complete: function(){
            },
            success: function( result ) {

                if(typeof result[0] === 'object'){

                    if(callback){
                        self.executeFunctionByName(callback, window, result[0], showMessage, location);
                    } else {
                        phDetails = result[0];
                    }
                }

            },
            error: function() {
                console.warn('some error occurred!');
            }
        });

        if (phDetails != null) return phDetails;
    },

    checkPharmaciesExpired: function(expire){

        var ret = true;

        if(expire !== null){

            var a = Date.parse(expire),
                b = new Date().setHours(0,0,0,0),
                diff = Math.abs(b-a),
                days = Math.ceil( diff / (1000 * 3600 * 24));


                if(days==0) ret = false;
        }
        return ret;
    },

    getPharmacies: function(callback){

        var self = this;

        // we already have farmacies in our local storage
        var stored = localStorage.getItem('pharmacies'),
            expire = localStorage.getItem('pharmacies_expire');


        if(!self.checkPharmaciesExpired(expire) && stored !== null ) return false;


        $.ajax( {
            dataType: 'json',
            url: self.baseUrl + "pharmacies/get_all_pharmacies_lite",
            type: "POST",
            cache: false,
            headers: {
                "Authorization" : self.token
            },
            data: {
                storecode: 'it'
            },
            beforeSend: function(){
            },
            complete: function(){
            },
            success: function( result ) {

                var setDate = new Date(new Date().setHours(0,0,0,0));

                localStorage.setItem('pharmacies',JSON.stringify(result));
                localStorage.setItem('pharmacies_expire',setDate);

                // Let's trigger the event to notify the map that the pharmacies are loaded
                const phMap = document.querySelector('.ph-map__locator');
                if (phMap) phMap.dispatchEvent(new Event('pharmaciesLoaded'));

                if(callback){
                    self.executeFunctionByName(callback,window);
                }
            },
            error: function() {
                console.warn('some error occoured!');
            }
        });

    },


    populateProductPhInfo: function(activePhObj){
        if(activePhObj === null) return false;
        var $el = $('#product-ph-info');
        $el.find('.ph-text').html(
            activePhObj.NomeFarmacia + '<br>' +
            activePhObj.Via + ' ' +
            activePhObj.CAP + ' ' +
            '(' + activePhObj.Provincia + ')'
            );
        $el.removeClass('hide');
    },

    returnPharmacyTimetable: function(time){

        if (time === '') return '<small class="ph-map__details__not-availabe">Dato non disponibile</small>';

        var time = JSON.parse(time);
        var ret = '';
        var translate = {
            'Monday' : 'Lunedì',
            'Tuesday' : 'Martedì',
            'Wednesday' : 'Mercoledì',
            'Thursday' : 'Giovedì',
            'Friday' : 'Venerdì',
            'Saturday' : 'Sabato',
            'Sunday' : 'Domenica'
        };

        for(i in time){
            if (time.hasOwnProperty(i)) {

                var el = time[i];
                ret+= '<tr>';
                    ret+= '<td class="tt-day">'+ translate[i] + '</td>';
                    ret+= '<td>';
                    if(el.IsOpen){
                        if(el.MorningFrom!='' && el.MorningFrom!='00:00') ret+= el.MorningFrom;
                        if(el.MorningTo!='' && el.MorningTo!='00:00') ret+= ' '+el.MorningTo;
                        ret+= ' - ';
                        if(el.AfternoonFrom!='' && el.AfternoonFrom!='00:00') ret+= el.AfternoonFrom;
                        if(el.AfternoonTo!='' && el.AfternoonTo!='00:00') ret+= ' '+el.AfternoonTo;
                    } else {
                        ret+= 'Chiuso';
                    }
                    ret+= '</td>';
                ret+= '</tr>';
            }
        }

        if(ret != '') ret = '<table>'+ ret  +'</table>';

        return ret;

    },

    returnPharmacyServicesList: function(services){
        var ret = '';

        for(i in services){
            ret+= '<li><svg class="anim" height="7" width="10"><use href="#theme_svg_checkmark" xlink:href="#theme_svg_checkmark"/></svg>'+ services[i] +'</li>'
        }

        return (ret != '') ? '<ul class="ph-map__details__services-list">'+ ret +'</ul>' : '<small class="ph-map__details__not-availabe">Dato non disponibile</small>' ;
    },

    populateAccountPhInfo: function(activePhObj){
        var ph = activePhObj || JSON.parse(localStorage.getItem('pharmacy_details'));
        if(ph === null) return false;

        var html = $('.account-ph__details-template').html()
            show_contacts = ((ph.FacebookLink == '' || ph.FacebookLink == null) && (ph.InstagramLink == '' || ph.InstagramLink == null) && (ph.TikTokLink == '' || ph.TikTokLink == null) && true == false && true == false) ? "hidden" : '';

        if(html == undefined) return false;

        var phPic = '';
        if(ph.FotoFarmacia != ''){
            phPic = ph.FotoFarmacia;
        } else if(ph.LogoFarmacia != ''){
            phPic = ph.LogoFarmacia;
        }

        html = html.replace('##IMG##',phPic);
        html = html.replace(/##TITLE##/g, (ph.NomeFarmacia != null) ? ph.NomeFarmacia : '' );
        html = html.replace('##RAGIONE##', ph.RagioneSociale1);
        html = html.replace('##TYPE##', (ph.AderenteReteFP==1) ? 'Farmacie Specializzate' : 'Farmacisti Preparatori' );
        html = html.replace('##ADDRESS##', ph.Via + ' ' + ph.CAP + ' ' + '(' + ph.Provincia + ')' );
        html = html.replace('##DESC##', ph.Descrizione );
        html = html.replace('##CODE##', ph.CodiceX3 );
        html = html.replace('##SELECTABLE##', (ph.Selectable == 1) ? ph.Selectable : 'not-selectable-details' );
        html = html.replace(/##CODE_ACTIVE##/g, (this.userPhCode == ph.CodiceX3) ? 1 : 0 );
        html = html.replace(/##HIDE_CONTACTS##/i, show_contacts );
        html = html.replace(/##WEB##/g, ph.UrlSitoWeb );
        html = html.replace(/##EMAIL##/g, ph.Email );
        html = html.replace(/##TEL##/g, ph.Telefono );
        html = html.replace(/##FB##/g, ph.FacebookLink );
        html = html.replace(/##INSTA##/g, (ph.InstagramLink != null) ? ph.InstagramLink : '' );
        html = html.replace(/##TIKTOK##/g, (ph.TikTokLink != null) ? ph.TikTokLink : '' );
        html = html.replace(/##FT##/g, ph.FarmacieDiTurno );
        html = html.replace('##TIMETABLE##', this.returnPharmacyTimetable(ph.OrarioFarmacia));
        html = html.replace('##SERVICES##', this.returnPharmacyServicesList(ph.ServicesDetails));


        if(ph.ServicesDetails == ''){
            html = html.replace('services', 'services hide');
        }

        if(ph.OrarioFarmacia == ''){
            html = html.replace('time_table', 'time_table hide');
        }

        $('.account-ph__details').html(html);

        $('.account-ph__details__desc').readmore({
            collapsedHeight: 60,
            moreLink: '<a href="#" class="rm-open theme-btn theme-btn--outline theme-btn--small">Leggi tutto</a>',
            lessLink: '<a href="#" class="rm-close theme-btn theme-btn--outline theme-btn--small">Chiudi</a>'
        });

        //change page title when displaying the selected pharmacy
        

    },

    populateSelect: function($select){

        var self = this;
        var pharmacies = JSON.parse(localStorage.getItem('pharmacies'));
        var activePh = $select.data('active-ph');
        var activePhObj = null;

        if(typeof pharmacies === 'object'){

            var opts = '';

            for (var i in pharmacies) {
                if(pharmacies[i].Selectable == 0){
                    pharmacies.splice(i,1);
                }
                if (pharmacies.hasOwnProperty(i)) {

                    var ph = pharmacies[i];
                    var optSel = '';
                    if(activePh === ph.CodiceX3){
                        optSel = ' selected';
                    }
                    opts+= '<option value="'+ ph.CodiceX3 +'"'+ optSel +'>'+ ph.NomeFarmacia + ' | '+ ph.Via + ' ' + ph.CAP +' '+ ph.Citta +' ('+ ph.Provincia +')</option>';
                }
            }
            if(opts!=''){
                opts = '<option></option>' + opts ;
                $select.html(opts);
            }



        }

        self.setPharmacyElements();

    },

    noResultNearbyInit: function(){

        var user_pos = JSON.parse(localStorage.getItem('pharmacies_user_pos')),
        $noResult = $('.pharmacy-select__no-result-msg'),
        self = this;

        if(user_pos != null){
            // If we already have the data stored we avoid call the api again
            this.noResultNearbySearch({
                 lat: user_pos.lat,
                 lng: user_pos.lng
            });

        } else{
            // Otherwise we ask to retrieve it from the browser
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    function(pos){

                        self.noResultNearbySearch({
                            lat: pos.coords.latitude,
                            lng: pos.coords.longitude
                        });
                    },
                    function(err){
                        $noResult.addClass("show");
                        console.warn(`ERROR(${err.code}): ${err.message}`);
                    }
                );
            }
        }

    },

    noResultNearbySearch: function(data){

        var self = this,
            pharmacies_nearby = JSON.parse(sessionStorage.getItem('pharmacies_nearby')),
            $noResult = $('.pharmacy-select__no-result-msg');

        // if we have already searched let's use stored results
        if(pharmacies_nearby != null){
            self.noResultNearbyShow(pharmacies_nearby);
            return;
        }

        $.ajax( {
            dataType: 'json',
            url: self.baseUrl + "pharmacies/get_nearest_pharmacies_lite",
            type: "POST",
            cache: false,
            headers: {
                "Authorization" : self.token
            },
            data: {
                Latitudine: data.lat,
                Longitudine: data.lng,
                storecode: 'it'
            },
            beforeSend: function(){



            },
            complete: function(){
            },
            success: function( result ) {

                if(typeof result === 'object'){

                    sessionStorage.setItem('pharmacies_nearby',JSON.stringify(result));
                    self.noResultNearbyShow(result);

                } else {
                    $noResult.addClass("show");
                }

            },
            error: function() {
                console.warn('some error occoured!');
            }
        });

    },

    noResultNearbyShow(pharmacies_nearby){


        var self = this,
            $container = $('.pharmacy-select__nearby-msg'),
            $noResult = $('.pharmacy-select__no-result-msg');

        var str = '';
        for(i in pharmacies_nearby){
            var ph = pharmacies_nearby[i];
            str+=`
            <div class="pharmacy-select__nearby-msg__result">
                <b>${ph.NomeFarmacia}</b><br>
                <small>${ph.Via} ${ph.Citta} ${ph.CAP} (${ph.Provincia})</small><br>
                Distanza: ${ph.Distance.toFixed(1)} Km.
                <div>
                    <a class="pharmacy-select__nearby-msg__btn theme-btn theme-btn--outline theme-btn--small" data-code="${ph.CodiceX3}" onclick="pharmacies.setPharmacy('${ph.CodiceX3}',true, location);" href="javascript:;">
                        <span class="def-text">Imposta come farmacia di riferimento</span>
                    </a>
                </div>
            </div>`;
        }

        // Populate results
        $container.find('.pharmacy-select__nearby-msg__results').html(str);

        // Show suggestion block
        $container.addClass('show');

        // Scroll page to have block into view
        window.goToPos($container);
    },

    createSelectObj: function(pharmacies){

        var count = 1;
        var tmp = [];
        var capCity = [];
        var selct2obj = {
            results: []
        }

        var stored = sessionStorage.getItem('pharmacies_by_zip'),
            expire = localStorage.getItem('pharmacies_expire');



        // If we have the cached information we return that
        if(!this.checkPharmaciesExpired(expire) && stored !== null ){
            return JSON.parse(stored)
        }

        // Otherwise we create a new object
        pharmacies.map(ph => {
            ph.id = ph.CodiceX3;
            ph.text = `${ph.NomeFarmacia}|${ph.Via} ${ph.CAP} ${ph.Citta} (${ph.Provincia})`;
            if(typeof tmp[ph.CAP] == 'undefined'){
                tmp[ph.CAP] = [];
                capCity[ph.CAP] = [ph.Citta];
            }

            // Skip pharmacies that are not selectable
            if(ph.Selectable == 1){
                tmp[ph.CAP].push(ph);
            }

            return ph;
        })


        for(cap in tmp){
            if(tmp[cap].length > 0){
                selct2obj.results.push({
                    'text': `${capCity[cap]} - ${cap}`,
                    'children' : tmp[cap]
                });
            }
        }

        // We store the new object for further usage
        // UN-255 Temporarly removed local storage
        sessionStorage.setItem('pharmacies_by_zip', JSON.stringify(selct2obj));

        return selct2obj;
    },

    initSelect: function($select){

        $select = $select || $('.pharmacy-select');

        var self = this;
        var placeholder = 'Cerca per CAP o comune';
        var pharmacies = JSON.parse(localStorage.getItem('pharmacies'));

        //Insert parameter for GTM request on selects (in both pdp and header)
        $select.attr("ph-set-type", $("body").hasClass("template-product") ? "product" : "header");

        // self.populateSelect($select);


        // Security check if pharmacies are not already loaded or select not populated
        if(typeof pharmacies === 'undefined' || pharmacies == null){
            this.getPharmacies('pharmacies.initSelect');
            return false;
        }

        var data = self.createSelectObj(pharmacies);

        $('.pharmacy-select__loader').fadeOut(300);



        function formatState(state){

            if (!state.id) return state.text;

            var pieces = state.text.split('|');
            var address = (typeof pieces[1] !== 'undefined') ? '<small> '+ pieces[1].trim() +'</small>' : '' ;
            var $ret = $(' <span>'+pieces[0].trim()+address+'</span>');
            return $ret;
        }

        function matchCustom(params, data) {
            // If there are no search terms, return all of the data
            if ($.trim(params.term) === '') {
              return data;
            }

            // Do not display the item if there is no 'text' property
            if (typeof data.text === 'undefined') {
              return null;
            }

            // We search through all the children
            var filteredChildren = [];
            $.each(data.children, function (idx, child) {
                if (child.CAP.toUpperCase().indexOf(params.term.toUpperCase()) > -1 || child.Citta.toUpperCase().indexOf(params.term.toUpperCase()) > -1) {
                filteredChildren.push(child);
                }
            });

            if (filteredChildren.length) {
                var modifiedData = $.extend({}, data, true);
                modifiedData.children = filteredChildren;

                // You can return modified objects from here
                // This includes matching the `children` how you want in nested data sets
                return modifiedData;
            }

            // `params.term` should be the term that is used for searching
            // `data.text` is the text that is displayed for the data object
            // if (data.CAP.indexOf(params.term) > -1 || data.CAP.indexOf(params.Citta) > -1) {
            //   var modifiedData = $.extend({}, data, true);
            //   modifiedData.text += ' (matched)';

            //   // You can return modified objects from here
            //   // This includes matching the `children` how you want in nested data sets
            //   return modifiedData;
            // }

            // Return `null` if the term should not be displayed
            return null;
        }

        if(!$select.hasClass("select2-hidden-accessible")){
            $select.select2({
                placeholder: placeholder,
                containerCssClass: 'pharmacy-select2',
                dropdownCssClass: 'pharmacy-select2__dropdown',
                templateResult: formatState,
                templateSelection: formatState,
                data: data.results,
                matcher: matchCustom,
                language: {
                    noResults: function(){
                        self.noResultNearbyInit();
                        return "Nessuna farmacia presente in questo CAP/Comune";
                    },
                    searching: function(){
                        $('.pharmacy-select__no-result-msg').removeClass("show");
                        $('.pharmacy-select__nearby-msg').removeClass("show");
                        return '';
                    }
                }
            });
        }

        // Preselect value if available
        if(self.userPhCode != null){
            $select.val(self.userPhCode).trigger('change');
        }

        $select.change(function(){
            var val = $(this).val();
            if ($(this).closest('.product__pharmacy-select-wrap').length > 0) {
                var location = 'product';
            } else if ($(this).closest('#ph-modal').length > 0) {
                var location = 'header';
            } else {
                var location = 'account';
            }

            if(val!='' && val != self.userPhCode){
                $(this).closest('#ph-modal').find(".mfp-close").removeClass("hidden");
                self.getPharmacy(val,'pharmacies.setPharmacy', true, false, location);
            }
        });
    },

    executeFunctionByName: function(functionName, context /*, args */) {
        var args = Array.prototype.slice.call(arguments, 2);
        var namespaces = functionName.split(".");
        var func = namespaces.pop();
        for(var i = 0; i < namespaces.length; i++) {
          context = context[namespaces[i]];
        }
        return context[func].apply(context, args);
    }
}